<style>

/* *{
  border: 1px red solid;
} */

.cont{
  position: fixed;
  z-index: 50;
  left: 0;
  right: 0;
  bottom: 0;
  height: 50px;
  display: grid;
  grid-template-columns: 20% 20% 20% 20% 20%;
  grid-template-rows: 36px auto;
  box-shadow: 0 -2px 5px rgb(0,0,0);
  text-align: center;
  background-color: rgba(0,0,0,0.8);
  color: #ccc;
  padding-top: 5px;
}

.profile-pic{
  width: 33px;
  border-radius: 33px;
}

.icon1{
  grid-row: 1;
  grid-column: 1;
}
.icon2{
  grid-row: 1;
  grid-column: 2;
}
.icon3{
  grid-row: 1;
  grid-column: 3;
}
.icon4{
  grid-row: 1;
  grid-column: 4;
}
.icon5{
  grid-row: 1;
  grid-column: 5;
}

.dot1{
  grid-row: 2;
  grid-column: 1;
}
.dot2{
  grid-row: 2;
  grid-column: 2;
}
.dot3{
  grid-row: 2;
  grid-column: 3;
}
.dot4{
  grid-row: 2;
  grid-column: 4;
}
.dot5{
  grid-row: 2;
  grid-column: 5;
}

.red-dot{
  margin: auto;
  height: 5px;
  width: 5px;
  border-radius: 5px;
  background-color: #0000;
}
.active{
  background-color: red;
}

[class*="icon-"] {
  font-size: 35px;
}
</style>

<div class="cont">
  
  <div class="icon1" on:click="{ () => push('/find-friends') }">
    <i class="icon-carbon-friendship"></i>
  </div>
  <div class="icon2" on:click="{ () => push('/search') }">
    <i class="icon-search"></i>
  </div>
  <div class="icon3" on:click="{ () => push('/events/popular') }">
    <i class="icon-home"></i>
  </div>
  <div class="icon4" on:click="{ () => push('/notifications') }">
    <i class="icon-codicon-bell"></i>
  </div>
  <div class="icon5" on:click="{ () => push('/profile') }">
    <!-- <img src="/i/alison-james-small.jpg" alt="profile pic" class="profile-pic"> -->
    {#if "uid" in me && me.uid && me.photoIds[0]}
      <img src="https://routes.hot0.workers.dev/fi/{localStorage.getItem('cookie')}/{localStorage.getItem('csrf')}/{me.uid}/{me.photoIds[0]}_t" alt="profile pic" class="profile-pic">
    {/if}
  </div>
  
  <div class="dot1">
    <div class="red-dot {locHelper('/find-friends') ? 'active' : ''}"></div>
  </div>
  <div class="dot2">
    <div class="red-dot {locHelper('/search') ? 'active' : ''}"></div>
  </div>
  <div class="dot3">
    <div class="red-dot {locHelper('/events/popular') ? 'active' : ''}"></div>
  </div>
  <div class="dot4">
    <div class="red-dot {locHelper('/notifications') ? 'active' : ''}"></div>
  </div>
  <div class="dot5">
    <div class="red-dot {locHelper('/profile') ? 'active' : ''}"></div>
  </div>
  
</div>

<script>

import {push, pop, replace, location} from 'svelte-spa-router';

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

let me = JSON.parse( localStorage.getItem("store") );
// console.log("me:", me);

function locHelper(id) {
  if (id == $location) return true;
  return false;
}


export const updateMe = async () => {
  me = JSON.parse( localStorage.getItem("store") );
  console.log("me:", me);
}

</script>